import { StoreInstance, StoreInstances, useStore } from '@doltech/core/lib/entity/store';
import { toStringQuery } from '@doltech/utils/lib/object';
import { getSnapshot, IStateTreeNode } from 'mobx-state-tree';
import Router from 'next/router';
import * as React from 'react';

export interface FilterStoreProps {
  search: string;
  sort: any;
  size: number;
  page?: number;
  isUpdateViaQuery?: boolean;
}

export interface FilterStoreActions {
  updateFilter(data: any): void;

  updateViaQuery(data: any): void;

  updateSearch(data: any): void;

  updateOrder(data: any): void;

  updatePage(data: any): void;

  updateSize(data: any): void;

  clearFilter(): void;

  applyFilter(): void;

  shouldUpdateViaQuery(data: any): void;

  showFilterButton(): void;

  toggleFilterButton(): void;

  hideFilterButton(): void;
}

export interface FilterStoreViews {
  countFilter: number;
  prepareRequest: any;
  isShowFilterButton: boolean;
}

export interface FilterStoreInstance
  extends StoreInstance,
    FilterStoreActions,
    FilterStoreViews,
    FilterStoreProps,
    IStateTreeNode {}

export interface FilterStore extends StoreInstances {
  filter: FilterStoreInstance;
}

export const useFilterStore = <S extends FilterStore>() => useStore<S>();

export const useFilter = <S extends FilterStore>() => {
  const store = useFilterStore<S>();
  const { filter } = store;
  const updateFilter = React.useCallback(
    (updateObject, updateUrl = true) => {
      filter.updateFilter({
        ...getSnapshot(filter),
        ...updateObject,
      });
      if (updateUrl) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const { isShowFilterButton, isUpdateViaQuery, initialed, ...rest } = filter;
        Router.push({
          pathname: Router.pathname,
          query: toStringQuery({ ...rest }),
        });
      }
    },
    [filter]
  );

  return { store, filter, updateFilter } as { filter: S['filter']; updateFilter };
};
